export default __webpack_public_path__ + "static/media/logo.f12d00df.png";